import React from 'react';

const TermCondition = () => {
    const containerStyle = {
        maxWidth: '1024px',
        margin: '0 auto',
        padding: '40px 16px',
        color: '#333',
        fontSize: '14px',
        lineHeight: '1.75'
    };

    const sectionTitle = {
        fontWeight: '600',
        marginTop: '24px',
        marginBottom: '10px',
    };

    const paragraph = {
        marginBottom: '16px',
    };

    const listStyle = {
        paddingLeft: '20px',
        marginBottom: '16px',
    };

    return (
        <div className="privacy_policy_inner">
            <div className="container">
                <h3>Terms and Conditions</h3>
                <div style={containerStyle}>
                    <p style={paragraph}>
                        Welcome to <strong>NannyLine</strong> – a platform designed to connect families with trusted childcare providers.
                    </p>
                    <p style={paragraph}>
                        By downloading, accessing, or using our website and/or mobile application ("Platform"), you agree to comply with and be bound by the following Terms and Conditions. Please read them carefully.
                    </p>

                    <h5 style={sectionTitle}>1. Acceptance of Terms</h5>
                    <p style={paragraph}>
                        By using NannyLine, you confirm that you are at least 18 years old and legally able to enter into a binding contract. If you do not agree to these Terms, you must not use our Platform.
                    </p>

                    <h5 style={sectionTitle}>2. Services Provided</h5>
                    <p style={paragraph}>
                        NannyLine is a service marketplace that allows families to find, book, and review caregivers (nannies, babysitters, etc.). We provide the technology to facilitate connections but do not employ or endorse any of the listed caregivers directly.
                    </p>

                    <h5 style={sectionTitle}>3. User Accounts</h5>
                    <p>To access certain features, you must create an account. You agree to:</p>
                    <ul style={listStyle}>
                        <li>Provide accurate and complete information</li>
                        <li>Keep your login credentials secure</li>
                        <li>Be responsible for all activity under your account</li>
                    </ul>

                    <h5 style={sectionTitle}>4. Use of the Platform</h5>
                    <p>You agree not to:</p>
                    <ul style={listStyle}>
                        <li>Use the platform for any unlawful purpose</li>
                        <li>Impersonate any person or entity</li>
                        <li>Post or transmit any offensive, abusive, or harmful content</li>
                        <li>Interfere with the platform’s operation or security</li>
                    </ul>

                    <h5 style={sectionTitle}>5. Payments and Bookings</h5>
                    <p style={paragraph}>
                        All bookings and payments made through the platform are subject to our service fee. Fees may vary based on the duration, caregiver profile, or additional services. By confirming a booking, you agree to the applicable charges.
                    </p>

                    <h5 style={sectionTitle}>6. Cancellation and Refunds</h5>
                    <p style={paragraph}>
                        Cancellation policies depend on the type of booking and may be subject to cancellation fees.
                    </p>

                    <h5 style={sectionTitle}>7. Background Checks and Verification</h5>
                    <p style={paragraph}>
                        We may perform basic background verification on caregivers, but we do not guarantee the completeness or accuracy of such checks. Users are encouraged to conduct their own due diligence before hiring.
                    </p>

                    <h5 style={sectionTitle}>8. Limitation of Liability</h5>
                    <p>NannyLine is not liable for:</p>
                    <ul style={listStyle}>
                        <li>Any injury, damage, or loss caused by caregivers</li>
                        <li>Any disputes between users</li>
                        <li>Service interruptions or unauthorized access to user data</li>
                    </ul>

                    <h5 style={sectionTitle}>9. Termination</h5>
                    <p style={paragraph}>
                        We reserve the right to suspend or terminate any account found violating these Terms, without prior notice or liability.
                    </p>

                    <h5 style={sectionTitle}>10. Intellectual Property</h5>
                    <p style={paragraph}>
                        All content on the platform, including logos, graphics, and software, is the property of NannyLine and is protected by intellectual property laws. You may not copy, reproduce, or distribute any content without our prior written consent.
                    </p>

                    <h5 style={sectionTitle}>11. Privacy</h5>
                    <p style={paragraph}>
                        Your use of the platform is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal data.
                    </p>

                    <h5 style={sectionTitle}>12. Modifications to Terms</h5>
                    <p style={paragraph}>
                        We reserve the right to update or change these Terms at any time. Continued use of the platform after any changes constitutes acceptance of those changes.
                    </p>

                    <h5 style={sectionTitle}>13. Contact Us</h5>
                    <p style={paragraph}>
                        If you have any questions or concerns regarding these Terms, please contact us at:
                    </p>
                    <p style={paragraph}>
                        <strong>NannyLine Support Team</strong><br />
                        Email: <a href="mailto:info@nanny-line.com">info@nanny-line.com</a><br />
                        Phone: +34 617 24 36 59
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermCondition;
